import { withStyles } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { InputForm } from "../../../../../../../../components/Input/InputDadosCadastraisPaciente";
import { Button } from "../../../../../../../../components/ui/Buttons";
import { NearMe } from "@material-ui/icons";
import { inject } from "mobx-react";
import { addHistoricoOrcamento } from "../../../../../../../../services/OrcamentoService";
import { observer } from "mobx-react-lite";
import { findAllHistoricoOrcamentoOdontologico } from "../../../../../../../../services/GerenciadorOrcamentosService";

const TabHistorico = observer(({ classes, orcamento, sujeitoAtencaoStore }) => {
  const [informacao, setInformacao] = useState("");
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadHistorico();
  }, []);

  const loadHistorico = async () => {
    const response = await findAllHistoricoOrcamentoOdontologico(orcamento.id);

    setHistorico(response);
  };

  const saveInformacao = async () => {
    try {
      setLoading(true);

      await addHistoricoOrcamento({
        orcamentoId: orcamento.id,
        informacao,
      });

      setInformacao("");
      await loadHistorico();

    } catch (error) {
      sujeitoAtencaoStore.openNotification(
        "Erro ao salvar a informação",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.containerList}>
        {historico.map((item, index) => {
          const { dataHoraLancamento, informacao, profissionalSaude } =
            item || {};
          const data = moment(dataHoraLancamento).format("DD/MM/YYYY HH:mm");

          return (
            <div key={index} className={classes.itemHistorico}>
              <div className={classes.itemCriacao}>
                {profissionalSaude?.nome} - {data}
              </div>
              <div className={classes.itemInformacao}>{informacao}</div>
            </div>
          );
        })}
      </div>
      <div className={classes.containerInput}>
        <InputForm
          id="prt-thi-inp-inf"
          value={informacao}
          className={classes.inputInformacao}
          rows={4}
          multiline
          onChange={(e) => setInformacao(e.target.value)}
        />
        <Button
          id="prt-thi-btn-env"
          color="primary"
          shape="circle"
          disabled={!informacao || loading}
          style={{ height: 40, width: 40 }}
          onClick={saveInformacao}
        >
          <NearMe className={classes.buttonSendIcon} />
        </Button>
      </div>
    </div>
  );
});

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    height: "calc(100% - 160px)",
  },
  scrollContainer: {
    height: "100%",
    "& > div": {
      height: "100%",
    },
  },
  containerList: {
    overflowY: "auto",
    height: "calc(100% - 18px)",
    borderRadius: "8px",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    padding: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    maxHeight: "250px",
  },
  itemHistorico: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  itemCriacao: {
    fontSize: "12px",
    fontWeight: "600",
  },
  inputInformacao: {
    background: "#F2F2F2",
    padding: "0 10px",
    borderRadius: 8,
    width: "93%",
    "& textArea": {
      padding: 0,
    },
  },
  containerInput: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
  },
  buttonSendIcon: {
    color: "white",
    width: 20,
    height: 20,
  },
};

const TabHistoricoWithStyles = withStyles(styles)(TabHistorico);
export default inject("sujeitoAtencaoStore")(TabHistoricoWithStyles);
